import { useEffect } from 'react';
import { buildMypageProfilePath, navigate } from './api';

/** @deprecated /mypage/profile?tab=exchange 으로 리다이렉트 */
export default function OneliveMobileMypageExchangeHistoryPage() {
  useEffect(() => {
    navigate(buildMypageProfilePath('exchange'));
  }, []);
  return null;
}
